import useModalRouter from './useModalRouter';
import { useEffect, useState } from 'react';
import { Modals } from '../../exports/Enums';
import useOrderSlots from '../../../../hooks/utility/useOrderSlots';
import { selectOrderMethod, selectScheduledFor } from '../../../../store/slices/OrderSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useUrlParams from '../../../../hooks/utility/useUrlParams';

const useRestaurantClosedFallback = (enabled: boolean = false) => {
  const { openModal } = useModalRouter();
  const params = useUrlParams();
  const { open_modal } = params;
  const orderMethod = useSelector(selectOrderMethod);
  const scheduledFor = useSelector(selectScheduledFor);
  const [now] = useState(() => moment());
  const startDate = now.format('YYYY-MM');
  const date = scheduledFor ? moment(scheduledFor) : now;
  const { isBusinessTime, isHolidaysLoading } = useOrderSlots({
    orderMethod,
    startDate,
    endDate: startDate,
    date,
  });

  const validate = (): boolean => {
    if (isBusinessTime(date.format())) {
      return true;
    }

    openModal({ id: Modals.RestaurantClosed });
  };

  useEffect(() => {
    if (!enabled || open_modal) {
      return;
    }

    if (isHolidaysLoading) {
      return;
    }

    validate();
  }, [isHolidaysLoading]);

  return { validate };
};

export default useRestaurantClosedFallback;
